import type {
  PaginatedResponse,
  PaginatedResult,
  PaginationState,
} from "api/types";

/**
 * Maps a paginated API response to a domain result using the provided mapper function
 */
export const mapPaginatedResponse = <TDto, TDomain>(
  response: PaginatedResponse<TDto>,
  mapper: (dto: TDto) => TDomain,
): PaginatedResult<TDomain> => ({
  items: response.data.map(mapper),
  links: response.links,
  meta: response.meta,
});

/**
 * Extracts pagination state (meta + links) from a PaginatedResult
 */
export const extractPaginationState = <T>(
  result: PaginatedResult<T>,
): PaginationState => ({
  meta: result.meta,
  links: result.links,
});
